module.exports = __webpack_public_path__ + "static/media/MITCertif.1a5ea312.png";